import React from "react";
import { MainApps } from "./@main-module/module-main";
import { CLIENT_ROUTES } from "./@app/client/routes";
import { elGlobals } from "./@css-style";
import { FontHeader } from "./@font-header";

export class Apps extends React.Component {
  render() {
    return (
      <MainApps className={elGlobals} storageKey={"KEMEN_PAREKRAF"} dataRouteMap={CLIENT_ROUTES}>
        <FontHeader
          fonts={[
            {
              src: "https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap",
            },
          ]}
        />
      </MainApps>
    );
  }
}
